<template>
  <div
    :class="{
      'hero' : true,
      'hike' : !merchant && !reseller,
      'reseller' : reseller,
      'clean' : merchant && !reseller
    }"
  >
    <div class="hero-logo">
      <div v-if="logo">
        <img :src="`https://s3.eu-west-2.amazonaws.com/seo-public/${logo}`">
      </div>
      <a
        v-else-if="!logo && !merchant"
        :href="`${preview ? 'javascript:;' : 'https://hikeseo.co'}`"
      >
        <img
          src="/assets/images/logo/logo-white.svg"
          alt="Hike SEO"
        >
      </a>
    </div>

    <div class="hero-title">
      {{ layout.title }}
      <!-- TODO: Whitelabel preview is missing custom description -->
    </div>

    <slot />
  </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  props: {
    logo: {
      type: [String, null],
      required: true,
    },
    merchant: {
      type: Boolean,
      default: false,
      required: false,
    },
    reseller: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    ...mapGetters('registration', [
      'layout',
      'discountMetaData', // remove if not used?
    ]),
  },
}
</script>

<style lang="scss" scoped>
.hero {
  display: flex;
  flex-direction: inherit;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  min-height: 75vh;
  position: relative;
  z-index: 20;
  row-gap: 1rem;

  .hero-title {
    text-align: center;
    font-family: 'DM Sans', sans-serif;
    font-weight: 700;
    color: black;
    line-height: 1.1;
    padding-left: 5%;
    padding-right: 5%;
    font-size: clamp(1.75rem, calc(2vw + 2rem), 3rem);
    margin-bottom: 1rem;

    small {
      font-size: 1.5rem;
      font-weight: 500;
    }
  }

  &.hike {
    background: #0B132B;

    .hero-title {
      color: white;
    }
  }

  &.reseller {
    background: #9D61EF;

    .hero-title {
      color: white;
    }
  }
}

.hero:after {
  width: 0;
  position: absolute;
  z-index: -1;
  content: " ";
  display: block;
  left: 0;
  bottom: 0;
  border-style: solid;
  border-width: 0 0 180px 100vw;
  border-color: transparent transparent #fafafa transparent;
}

.hero-logo {
  color: red;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin-top: 30px;
  margin-bottom: 30px;

  img {
    max-width: 250px;
    min-width: 130px;
    margin: 10px 0;
  }
}

.hero-logo svg {
  width: 100px;
  margin: 25px 20px;
  height: auto;
}
</style>
